import { getTargetContainersExceptPageOverlay } from '../utility/utility_controller'
import initVimeoSDKPlayers, { playerInstances } from './vimeo_init_sdk_players'

var $target = undefined
var lastTypeOfContentThatIsReady = undefined
var bindOnContentReady = function () {
	window.laytheme.on('content_ready', function (typeOfContentThatIsReady) {
		$target = getTargetContainersExceptPageOverlay(typeOfContentThatIsReady)
		initVimeoSDKPlayers($target.find('iframe[src*="player.vimeo.com"]'))
		setTimeout(function () {
			initPlayerControls($target)
		}, 0)
		lastTypeOfContentThatIsReady = typeOfContentThatIsReady
	})

	window.laytheme.on('overlayshown', function ($newTarget) {
		$target = $newTarget
		// only do all this once per page overlay:
		if ($target.hasClass('lay-overlay-was-opened-at-least-once')) {
			return
		}
		initVimeoSDKPlayers($target.find('iframe[src*="player.vimeo.com"]'))
		setTimeout(function () {
			initPlayerControls($target)
		}, 0)
	})

	window.laytheme.on('overlayhidden', function () {
		$target = getTargetContainersExceptPageOverlay(lastTypeOfContentThatIsReady)
		// dont need to do initPlayerControls again, because this page's thumbnailgrid was already initialized
	})

	// A lazy-loaded Vimeo iframe (Lay Options -> "Use Lazy Loading for Vimeo
	// videos") only gets its src when it scrolls into view — after the
	// content_ready pass that normally wires custom controls. Wire them up now.
	window.laytheme.on('lay_iframe_lazyloaded', function (iframe) {
		if (!iframe || typeof Vimeo == 'undefined') {
			return
		}
		var $el = jQuery(iframe)
		if (!$el.closest('.lay-vimeo-custom-controls').length) {
			return
		}
		if (!/player\.vimeo\.com/.test(iframe.getAttribute('src') || '')) {
			return
		}
		if ($el.hasClass('initialized')) {
			return
		}
		$el.addClass('initialized')
		new CustomControls($el)
	})
}

var CustomControls = function ($el) {
	this.$el = $el
	this.parent = $el[0].parentNode

	var controlsMarkup = '<div class="lay-vimeo-custom-controls">' + '<div class="lay-vimeo-playicon-custom">' + '<img src="' + layData.playicon + '" alt=""/>' + '</div>' + '<div class="lay-vimeo-playpause">' + '<svg class="lay-vimeo-play" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' + '<path d="M8 5L19 12L8 19V5Z" fill="white"/>' + '</svg>' + '<svg class="lay-vimeo-pause" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' + '<path d="M8 5H12V19H8V5Z" fill="white"/>' + '<path d="M16 5H20V19H16V5Z" fill="white"/>' + '</svg>' + '</div>' + '<div class="lay-controls-flex-wrap">' + '<div class="lay-vimeo-seekbar-outer">' + '<div class="lay-vimeo-seekbar">' + '<div class="lay-vimeo-seekbar-inner"></div>' + '</div>' + '</div>' + '<div class="lay-vimeo-volume">' + '<div class="lay-vimeo-volume-button">' + '<svg class="lay-vimeo-volume-on" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' + '<path d="M11 5L6 9H2V15H6L11 19V5Z" fill="white"/>' + '<path d="M15.54 8.46C16.4774 9.39764 17.004 10.6692 17.004 11.995C17.004 13.3208 16.4774 14.5924 15.54 15.53" stroke="white" stroke-width="2"/>' + '<path d="M19.07 4.93C20.9447 6.80528 21.9979 9.34836 21.9979 12C21.9979 14.6516 20.9447 17.1947 19.07 19.07" stroke="white" stroke-width="2"/>' + '</svg>' + '<svg class="lay-vimeo-volume-off" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' + '<path d="M11 5L6 9H2V15H6L11 19V5Z" fill="white"/>' + '<path d="M23 9L17 15" stroke="white" stroke-width="2"/>' + '<path d="M17 9L23 15" stroke="white" stroke-width="2"/>' + '</svg>' + '</div>' + '<div class="lay-vimeo-volume-slider-outer">' + '<div class="lay-vimeo-volume-slider">' + '<div class="lay-vimeo-volume-slider-inner"></div>' + '</div>' + '</div>' + '</div>' + '<div class="lay-vimeo-share">' + '<svg width="18" height="18" viewBox="0 0 256 256" xmlns="http://www.w3.org/2000/svg">' + '<g> <path fill="#ffffff" d="M246,101.8L141.1,10v53.7C10,95.2,10,246,10,246s45.6-106,131.1-106v53.6L246,101.8z"/></g>' + '</svg>' + '</div>' + '<div class="lay-vimeo-fullscreen"></div>' + '</div>' + '</div>'
	this.parent.insertAdjacentHTML('beforeend', controlsMarkup)

	this.controls = this.parent.querySelector('.lay-vimeo-custom-controls')
	this.seekbar = this.controls.querySelector('.lay-vimeo-seekbar')
	this.seekbarInner = this.seekbar.querySelector('.lay-vimeo-seekbar-inner')
	this.playIcon = this.controls.querySelector('.lay-vimeo-play')
	this.pauseIcon = this.controls.querySelector('.lay-vimeo-pause')
	this.playPauseButton = this.controls.querySelector('.lay-vimeo-playpause')
	this.customPlayPauseButton = this.controls.querySelector('.lay-vimeo-playicon-custom')

	this.shareButton = this.controls.querySelector('.lay-vimeo-share')
	this.volumeButton = this.controls.querySelector('.lay-vimeo-volume-button')
	this.volumeOnIcon = this.controls.querySelector('.lay-vimeo-volume-on')
	this.volumeOffIcon = this.controls.querySelector('.lay-vimeo-volume-off')
	this.volumeSlider = this.controls.querySelector('.lay-vimeo-volume-slider')
	this.volumeSliderInner = this.controls.querySelector('.lay-vimeo-volume-slider-inner')
	this.seekbarOuter = this.controls.querySelector('.lay-vimeo-seekbar-outer')
	this.volumeSliderOuter = this.controls.querySelector('.lay-vimeo-volume-slider-outer')
	this.fullscreenButton = this.controls.querySelector('.lay-vimeo-fullscreen')

	// Create fullscreen icon with customizable parameters
	this.createFullscreenIcon = function (options = {}) {
		const defaults = {
			strokeWidth: 2,
			cornerLength: 4,
			color: 'white',
			size: 24,
		}
		const config = { ...defaults, ...options }

		const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg')
		svg.setAttribute('width', config.size)
		svg.setAttribute('height', config.size)
		svg.setAttribute('viewBox', '0 0 24 24')
		svg.setAttribute('fill', 'none')
		svg.setAttribute('xmlns', 'http://www.w3.org/2000/svg')

		// Create the 4 corner paths - L shapes pointing outward from center
		const corners = [
			// Top-left corner - L pointing up and left (outward)
			`M${4 + config.cornerLength} 4L4 4L4 ${4 + config.cornerLength}`,
			// Top-right corner - L pointing up and right (outward)
			`M${20 - config.cornerLength} 4L20 4L20 ${4 + config.cornerLength}`,
			// Bottom-left corner - L pointing down and left (outward)
			`M${4 + config.cornerLength} 20L4 20L4 ${20 - config.cornerLength}`,
			// Bottom-right corner - L pointing down and right (outward)
			`M${20 - config.cornerLength} 20L20 20L20 ${20 - config.cornerLength}`,
		]

		corners.forEach((pathData) => {
			const path = document.createElementNS('http://www.w3.org/2000/svg', 'path')
			path.setAttribute('d', pathData)
			path.setAttribute('stroke', config.color)
			path.setAttribute('stroke-width', config.strokeWidth)
			path.setAttribute('stroke-linecap', 'round')
			path.setAttribute('stroke-linejoin', 'round')
			svg.appendChild(path)
		})

		return svg
	}

	// Initialize fullscreen icon with default settings
	if (this.fullscreenButton) {
		this.fullscreenButton.appendChild(this.createFullscreenIcon())
	}

	// Method to update fullscreen icon with new parameters
	this.updateFullscreenIcon = function (options = {}) {
		if (this.fullscreenButton) {
			// Clear existing icon
			this.fullscreenButton.innerHTML = ''
			// Create new icon with options
			this.fullscreenButton.appendChild(this.createFullscreenIcon(options))
		}
	}

	// Get player from the Map instead of dataset
	this.player = playerInstances.get(this.$el[0])
	if (!this.player) {
		this.player = new Vimeo.Player(this.$el[0])
		// Register it so destroyDetachedPlayers() can tear it down on navigation
		// instead of leaking this fallback-path player.
		playerInstances.set(this.$el[0], this.player)
		console.error('No player instance found for this iframe')
		//return
	}

	// Variables to track dragging state
	this.isSeeking = false
	this.isVolumeDragging = false
	this.lastSeekTime = 0
	this.lastSeekPosition = 0
	this.seekThrottle = 100 // milliseconds between actual seek operations

	// Seek bar drag functionality - Mouse events
	this.seekbarOuter.addEventListener('mousedown', function (e) {
		e.stopPropagation()
		_this.isSeeking = true
		_this.handleSeek(e)
	})

	// Seek bar drag functionality - Touch events
	this.seekbarOuter.addEventListener('touchstart', function (e) {
		e.stopPropagation()
		_this.isSeeking = true
		_this.handleSeek(e.touches[0])
	})

	document.addEventListener('mousemove', function (e) {
		e.stopPropagation()
		if (_this.isSeeking) {
			_this.handleSeek(e)
		}
		if (_this.isVolumeDragging) {
			_this.handleVolumeDrag(e)
		}
	})

	document.addEventListener(
		'touchmove',
		function (e) {
			if (_this.isSeeking) {
				e.preventDefault()
				e.stopPropagation()
				_this.handleSeek(e.touches[0])
			}
			if (_this.isVolumeDragging) {
				e.preventDefault()
				e.stopPropagation()
				_this.handleVolumeDrag(e.touches[0])
			}
		},
		{ passive: false }
	)

	document.addEventListener('mouseup', function (e) {
		e.stopPropagation()
		_this.isSeeking = false
		_this.isVolumeDragging = false
	})

	document.addEventListener('touchend', function (e) {
		// Do final seek on touchend if we were seeking
		if (_this.isSeeking && _this.lastSeekPosition !== null) {
			_this.player.getDuration().then(function (duration) {
				_this.player.setCurrentTime(_this.lastSeekPosition * duration)
			})
		}
		_this.isSeeking = false
		_this.isVolumeDragging = false
		_this.lastSeekPosition = null
	})

	// Volume slider drag functionality - Mouse events
	this.volumeSliderOuter.addEventListener('mousedown', function (e) {
		e.stopPropagation()
		_this.isVolumeDragging = true
		_this.handleVolumeDrag(e)
	})

	// Volume slider drag functionality - Touch events
	this.volumeSliderOuter.addEventListener('touchstart', function (e) {
		e.stopPropagation()
		_this.isVolumeDragging = true
		_this.handleVolumeDrag(e.touches[0])
	})

	// Handle seek during drag
	this.handleSeek = function (e) {
		if (e.stopPropagation) {
			e.stopPropagation()
		}
		var rect = this.seekbarOuter.getBoundingClientRect()
		var pos = Math.max(0, Math.min(1, (e.clientX - rect.left) / rect.width))

		// Always update the UI immediately
		this.seekbarInner.style.width = `${pos * 100}%`
		this.lastSeekPosition = pos

		// Throttle actual video seeking to avoid performance issues
		var now = Date.now()
		if (now - this.lastSeekTime >= this.seekThrottle) {
			this.player.getDuration().then(
				function (duration) {
					this.player.setCurrentTime(pos * duration)
				}.bind(this)
			)
			this.lastSeekTime = now
		}
	}

	// Handle volume during drag
	this.handleVolumeDrag = function (e) {
		var rect = this.volumeSliderOuter.getBoundingClientRect()
		var pos = Math.max(0, Math.min(1, 1 - (e.clientY - rect.top) / rect.height))
		this.player.setVolume(pos)
		this.updateVolumeSlider(pos)
	}

	// Add click handler for seeking (keep existing click handler for single clicks)
	this.seekbarOuter.addEventListener('click', function (e) {
		if (!_this.isSeeking) {
			// Only handle click if not dragging
			var rect = this.getBoundingClientRect()
			var pos = (e.clientX - rect.left) / rect.width
			_this.player.getDuration().then(function (duration) {
				_this.player.setCurrentTime(pos * duration)
			})
		}
	})

	// Add click handler to controls container
	this.controls.addEventListener('click', function (e) {
		e.stopPropagation()
		// Only trigger if click was directly on the controls container
		if (e.target === this) {
			_this.player.getPaused().then(function (paused) {
				if (paused) {
					_this.player.play()
					_this.updatePlayPauseIcon(false)
					// we set to dirty to false here, so we autoplay again when scrolled to
					_this.$el[0].dataset.dirty = false
				} else {
					_this.player.pause()
					_this.updatePlayPauseIcon(true)
					// we set dirty to false here so we dont autoplay again when scrolled to
					_this.$el[0].dataset.dirty = true
				}
			})
		}
	})

	this.iframe = this.parent.querySelector('iframe')
	var _this = this

	// Set initial state
	this.player.getPaused().then(function (paused) {
		_this.updatePlayPauseIcon(paused)
		if (!paused) {
			_this.$el[0].closest('.video').classList.add('lay-vimeo-playing')
		}
	})

	// Handle play/pause button click
	this.playPauseButton.addEventListener('click', function (e) {
		e.stopPropagation()
		_this.player.getPaused().then(function (paused) {
			if (paused) {
				_this.player.play()
			} else {
				_this.player.pause()
			}
		})
	})
	this.customPlayPauseButton.addEventListener('click', function (e) {
		e.stopPropagation()
		_this.player.getPaused().then(function (paused) {
			if (paused) {
				_this.player.play()
			} else {
				_this.player.pause()
			}
		})
	})

	// Update icon on play/pause events
	this.player.on('play', function () {
		_this.updatePlayPauseIcon(false)
		_this.$el[0].closest('.video').classList.add('lay-vimeo-playing')
		_this.$el[0].closest('.video').classList.remove('lay-vimeo-paused')
	})

	this.player.on('pause', function () {
		_this.updatePlayPauseIcon(true)
		_this.$el[0].closest('.video').classList.remove('lay-vimeo-playing')
		_this.$el[0].closest('.video').classList.add('lay-vimeo-paused')
	})

	this.player.on('timeupdate', function (data) {
		_this.seekbarInner.style.width = `${data.percent * 100}%`
	})

	// Add volume button click handler
	this.volumeButton.addEventListener('click', function (e) {
		e.stopPropagation()
		_this.player.getMuted().then(function (muted) {
			_this.player.setMuted(!muted)
			_this.updateVolumeIcon(!muted)
		})
	})

	// Add volume slider click handler (keep existing click handler for single clicks)
	this.volumeSliderOuter.addEventListener('click', function (e) {
		e.stopPropagation()
		if (!_this.isVolumeDragging) {
			// Only handle click if not dragging
			var rect = this.getBoundingClientRect()
			var pos = 1 - (e.clientY - rect.top) / rect.height
			_this.player.setVolume(pos)
			_this.updateVolumeSlider(pos)
		}
	})

	// Add fullscreen button click handler
	this.fullscreenButton.addEventListener('click', function (e) {
		e.stopPropagation()
		_this.player.getFullscreen().then(function (fullscreen) {
			if (fullscreen) {
				_this.player.exitFullscreen()
			} else {
				_this.player.requestFullscreen()
			}
		})
	})

	// Add share button click handler
	if (this.shareButton) {
		this.shareButton.addEventListener('click', function (e) {
			e.preventDefault()
			e.stopPropagation()
			_this.handleShareClick()
		})
	}

	// Listen for fullscreen changes to toggle default controls
	this.player.on('fullscreenchange', function (data) {})

	// Set initial volume state
	this.player.getMuted().then(function (muted) {
		_this.updateVolumeIcon(!muted)
	})

	this.player.getVolume().then(function (volume) {
		_this.player.getMuted().then(function (muted) {
			_this.updateVolumeSlider(volume, muted)
		})
	})

	// Update volume slider on volume change
	this.player.on('volumechange', function (data) {
		_this.updateVolumeSlider(data.volume, data.muted)
		_this.updateVolumeIcon(!data.muted)
	})

	// Check if video should autoplay
	/*if (this.iframe.hasAttribute('data-autoplay')) {
		this.player.play()
	}*/
}

CustomControls.prototype.updatePlayPauseIcon = function (paused) {
	if (paused) {
		this.playIcon.style.display = 'block'
		this.pauseIcon.style.display = 'none'
	} else {
		this.playIcon.style.display = 'none'
		this.pauseIcon.style.display = 'block'
	}
}

CustomControls.prototype.updateVolumeIcon = function (unmuted) {
	if (unmuted) {
		this.volumeOnIcon.style.display = 'block'
		this.volumeOffIcon.style.display = 'none'
	} else {
		this.volumeOnIcon.style.display = 'none'
		this.volumeOffIcon.style.display = 'block'
	}
}

CustomControls.prototype.updateVolumeSlider = function (volume, muted) {
	if (muted) {
		this.volumeSliderInner.style.height = '0%'
	} else {
		this.volumeSliderInner.style.height = `${volume * 100}%`
	}
}

CustomControls.prototype.handleShareClick = function () {
	// Get the Vimeo video URL from the iframe
	const iframe = this.parent.querySelector('iframe')
	if (!iframe) return

	const src = iframe.getAttribute('data-src') || iframe.getAttribute('src')
	if (!src) return

	// Extract video ID from the Vimeo URL
	const videoIdMatch = src.match(/\/video\/(\d+)/)
	if (!videoIdMatch) return

	const videoId = videoIdMatch[1]
	const vimeoUrl = `https://vimeo.com/${videoId}`

	// Check if clipboard API is available (requires HTTPS)
	if (navigator.clipboard && window.isSecureContext) {
		// Use modern clipboard API
		navigator.clipboard
			.writeText(vimeoUrl)
			.then(() => {
				this.showShareMessage()
			})
			.catch((err) => {
				console.error('Failed to copy URL: ', err)
				// Fallback for older browsers
				this.fallbackCopyToClipboard(vimeoUrl)
			})
	} else {
		// Use fallback method for Firefox and other browsers
		this.fallbackCopyToClipboard(vimeoUrl)
	}
}

CustomControls.prototype.fallbackCopyToClipboard = function (text) {
	const textArea = document.createElement('textarea')
	textArea.value = text
	// Make the textarea invisible and position it off-screen
	textArea.style.position = 'fixed'
	textArea.style.left = '-9999px'
	textArea.style.top = '-9999px'
	textArea.style.opacity = '0'
	textArea.style.pointerEvents = 'none'
	document.body.appendChild(textArea)
	textArea.focus()
	textArea.select()
	try {
		document.execCommand('copy')
		this.showShareMessage()
	} catch (err) {
		console.error('Fallback copy failed: ', err)
	}
	document.body.removeChild(textArea)
}

CustomControls.prototype.showShareMessage = function () {
	// Create message element if it doesn't exist
	let messageEl = this.controls.querySelector('.lay-share-message')
	if (!messageEl) {
		this.controls.insertAdjacentHTML('beforeend', '<div class="lay-share-message">Link copied</div>')
		messageEl = this.controls.querySelector('.lay-share-message')
	}

	messageEl.style.display = 'block'

	// Hide message after 3 seconds
	setTimeout(() => {
		messageEl.style.transition = 'opacity 0.3s ease'
		setTimeout(() => {
			messageEl.style.opacity = '0'
		}, 0)
		setTimeout(() => {
			messageEl.style.display = 'none'
			messageEl.remove()
		}, 300) // Wait for fade out animation
	}, 3000)
}

var initPlayerControls = function ($target) {
	var $vimeoplayers = $target.find('.lay-vimeo-custom-controls iframe[src*="player.vimeo.com"]')
	var $vimeoplayers_not_initialized = $vimeoplayers.not('.initialized')
	if ($vimeoplayers_not_initialized.length > 0) {
		$vimeoplayers_not_initialized.each(function () {
			$vimeoplayers_not_initialized.addClass('initialized')
		})

		$vimeoplayers_not_initialized.each(function () {
			var $el = jQuery(this)
			new CustomControls($el)
		})
	}
}

var i = function () {
	if (typeof Vimeo == 'undefined') {
		return
	}
	bindOnContentReady()
}

var vimeoplayer_custom_controls = {
	i: i,
}

export default vimeoplayer_custom_controls
